module.exports = __webpack_public_path__ + "static/img/1_17_1.99d03f66.jpg";